
<div class="container">
  <!-- <mat-label>טעינת קובץ</mat-label> -->
  <mat-chip-listbox class="chip-listbox compact-chips" #chipList>

    @if (selectedFile) {
      <mat-chip-option (removed)="remove(selectedFile)">
        {{selectedFile.name}}
        <button matChipRemove class="remove-btn">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-option>
    }

  </mat-chip-listbox>

  <button mat-flat-button color="primary" class="upload-btn" onclick="files.click()">טעינת קובץ</button>
  <input type="file" id="files" (change)="fileChangeEvent($event)" [accept]="fileTypes()"/>
</div>

